import type { ClassificationParam } from '../types';

export const buildDataItemsParam = (
  items: ClassificationParam[],
  key: keyof ClassificationParam | undefined = 'name',
): string => items.map((item) => item[key]).join(', ');
